<template>
    <div id="chat-message-area">
        <AICopilot v-if="aiCopilot" @close="aiCopilot = null" :payload="aiCopilot" :contact="contact" />
        <VisitorTyping v-if="visitorTypingMessage" :message="visitorTypingMessage" />
        <ReplyMessage v-if="repliedMessage()" :message="repliedMessage()" :visitor-name="contact.fullname" />
        <FileUploading v-if="mediaUploading.enabled" :percentage="mediaUploading.percentage" />
        <MessageArea
            ref="messageArea"
            :contact="contact"
            :messageSyncRunning="messageSyncRunning"
            @media-message="$emit('media-message', $event)"
            @ai-copilot="openAICopilot"
        />
    </div>
</template>

<script>
import MessageArea from "./components/MessageArea.vue";
import AICopilot from "./components/AICopilot.vue";
import VisitorTyping from "./components/VisitorTyping.vue";
import { mapState } from "vuex";
import ReplyMessage from "./components/ReplyMessage.vue";
import FileUploading from "./components/FileUploading.vue";
import MessageSkeleton from "../MessageSkeleton.vue";

export default {
    name: "ChatMessageArea",
    components: { MessageSkeleton, FileUploading, ReplyMessage, VisitorTyping, AICopilot, MessageArea },
    props: {
        contact: {
            type: Object,
            default: () => ({}),
        },
        messageSyncRunning: {
            type: Boolean,
            default: false,
        },
        visitorTypingMessage: {
            type: String,
            default: null,
        },
        mediaUploading: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            aiCopilot: null,
        };
    },
    computed: {
        ...mapState({
            replyToMessages: (state) => state.chat.pinnedReplyToMessages,
        }),
    },
    methods: {
        repliedMessage() {
            return this.$_.get(this.replyToMessages, this.contact.lastConversation?._id, null);
        },
        openAICopilot(payload) {
            this.aiCopilot = payload;
        },
    },
};
</script>
<style lang="scss" scoped>
#chat-message-area {
}
</style>
